module.exports = __webpack_public_path__ + "img/image16@2x.19d9aa37.png";